import React, { useState } from "react";
import "./Sidebar.css";

import {
Users,
Layers,
ShoppingCart,
Package,
Truck,
FileText,
Wallet,
BarChart3,
ArrowLeft,
Power
} from "lucide-react";

const sidebarItems = [
{ label: "PARTY LIST", icon: <Users size={18} /> },
{ label: "MASTER", icon: <Layers size={18} /> },
{ label: "PURCHASE", icon: <ShoppingCart size={18} /> },
{ label: "STOCK", icon: <Package size={18} /> },
{ label: "DELIVERY", icon: <Truck size={18} /> },
{ label: "INVOICE", icon: <FileText size={18} /> },
{ label: "RECEIPT", icon: <Wallet size={18} /> },
{ label: "ALL REPORTS", icon: <BarChart3 size={18} /> },
{ label: "BACK", icon: <ArrowLeft size={18} /> },
{ label: "EXIT", icon: <Power size={18} /> }
];

export default function Sidebar({ onSelect }) {

const [open, setOpen] = useState(false);

return (
<>
{/* MOBILE HEADER */} <div className="mobile-header">
<button
className="hamburger"
onClick={() => setOpen(true)}
>
☰ </button>


    <div className="mobile-title">
      ORANGE TRADINGS
    </div>

    <div className="mobile-search">🔍</div>
  </div>

  {/* OVERLAY */}
  {open && (
    <div
      className="drawer-overlay"
      onClick={() => setOpen(false)}
    />
  )}

  {/* SIDEBAR */}
  <div className={`sidebar ${open ? "open" : ""}`}>

    <div className="drawer-header">
      <span>Menu</span>
      <button
        className="drawer-close"
        onClick={() => setOpen(false)}
      >
        ✕
      </button>
    </div>

    {sidebarItems.map((item) => (
      <button
        key={item.label}
        className="sidebar-btn"
        onClick={() => {
          onSelect(item.label);
          setOpen(false);
        }}
      >
        <span className="sidebar-icon">
          {item.icon}
        </span>

        <span className="sidebar-text">
          {item.label}
        </span>
      </button>
    ))}

  </div>
</>


);
}
